export enum HARDWARE_CONNECT_EVENTS {
    OPEN_DRAWER = "OpenDrawer",
    WEIGHT = "Weigh",
    RECEIPT = "Receipt",
    PRINT_PREFORMATTED = "PrintPreformatted",
    SEND_PRINT = "SendPrint",
    TAGS = "Tags",
    PRINT_DOCKETS = "PrintDockets",
    DBF = "Dbf",
    SALE = "Sale",
    SALES = "Sales",
    GIFT_CARDS = "GiftCards",
    GET_CONFIG = "GetConfig",
    SET_CONFIG = "SetConfig",
    BROADCAST = "Broadcast",
    UPDATE_CUSTOMER = "UpdateCustomer",
}

export enum HARDWARE_CONNECT_BROADCAST_EVENTS {
    CALLBACK = "CALLBACK",
    NOT_CONNECTED = "NOT_CONNECTED",
    CONNECTED = "CONNECTED",
    CUSTOMER_OWING = "CUSTOMER_OWING",
    KITCHEN_DISPLAY = "KITCHEN_DISPLAY",
}
